<template>
  <div class="export-page page">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "ExportModule"
};
</script>
